import styles from './PageLoading.module.scss'
import { useStoreSelector } from 'hooks/store.ts'
import { useTranslation } from 'react-i18next'
import { PageLoadingProps } from 'components/page-loading/types.ts'
import { Button, Card, Loader } from '@boltenergy-be/design-system'
import { logout } from 'utils/app.ts'
import { getUserTypeLoginPage } from 'utils/user.ts'
import { useNavigate } from 'react-router'
import parse from 'html-react-parser'
import useNetworkState from 'hooks/useNetworkState.ts'

const PageLoading = ({ isLoading, showError }: PageLoadingProps) => {
  // Redux
  const { error } = useStoreSelector((store) => store.contact)
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation()

  // Network
  const { isOnline, restoredConnection } = useNetworkState()

  // Router
  const navigate = useNavigate()

  return (
    <div data-app-loading={true} className={styles.loading}>
      {!showError && isLoading && <Loader size={32} className={styles.loader} />}
      {(showError || error) && (
        <Card className={styles.card}>
          <Card.Title variant="h3">
            {t(($) =>
              !isOnline || restoredConnection ? $.network[restoredConnection ? 'restored' : 'warning'].title : $.somethingWentWrong.title
            )}
          </Card.Title>
          <p>
            {parse(
              t(($) =>
                !isOnline || restoredConnection
                  ? $.network[restoredConnection ? 'restored' : 'warning'].description
                  : $.somethingWentWrong.description
              )
            )}
          </p>

          {isOnline && !restoredConnection && (
            <Button variant="secondary" onClick={() => logout(() => void navigate(getUserTypeLoginPage(userType)))}>
              {t(($) => $.nav.logout)}
            </Button>
          )}

          {restoredConnection && (
            <Button variant="secondary" onClick={() => window.location.reload()}>
              {t(($) => $.network.restored.reload)}
            </Button>
          )}
        </Card>
      )}
    </div>
  )
}

export default PageLoading
